export default __webpack_public_path__ + "static/media/mentoring-shaded.c52de4b5.png";